import { SupportedTokens } from '@sovryn/contracts';
export const tokensDisplayName = {
    [SupportedTokens.bnbs]: 'BNB',
    [SupportedTokens.rbtc]: 'BTC',
    [SupportedTokens.eths]: 'ETH',
    [SupportedTokens.fish]: 'FISH',
    [SupportedTokens.wrbtc]: 'BTC',
};
export const getTokenDisplayName = (token) => tokensDisplayName[token === null || token === void 0 ? void 0 : token.toLowerCase()] || (token === null || token === void 0 ? void 0 : token.toUpperCase());
